import { useTranslation } from 'react-i18next';
import { Box, Card, Container, Image, SimpleGrid, Stack, Text, Title } from '@mantine/core';

interface OpportunityItem {
  readonly key: string;
  readonly icon: string;
}

// Фирменные иконки из набора benefit-* — тот же визуальный язык, что в блоке преимуществ.
const ITEMS: readonly OpportunityItem[] = [
  { key: 'edo', icon: 'benefit-process' },
  { key: 'financing', icon: 'benefit-diamond' },
];

// «Делаем сервис удобным»: ЭДО/ПЭП/КЭП и торговое финансирование. Белый раздел, сверху зелёная линия.
export default function Opportunities() {
  const { t } = useTranslation();

  return (
    <Box bg="white" style={{ borderTop: '3px solid var(--mantine-color-brand-7)' }}>
      <Container size="lg" py={{ base: 'xl', md: 56 }}>
        <Stack gap={4} mb="xl">
          <Title order={2} fz={{ base: 26, sm: 30 }}>{t('landing.opportunities.title')}</Title>
          <Text c="gray.7" fz="lg">
            {t('landing.opportunities.subtitle')}
          </Text>
        </Stack>

        <SimpleGrid cols={{ base: 1, md: 2 }} spacing="lg">
          {ITEMS.map(({ key, icon }) => (
            <Card key={key} withBorder bg="white" padding="xl" radius={0}>
              <Stack gap="md">
                <Image src={`/images/icons/${icon}.svg`} alt="" w={48} h={48} />
                <Title order={3}>{t(`landing.opportunities.${key}.title`)}</Title>
                <Text>{t(`landing.opportunities.${key}.text1`)}</Text>
                <Text c="gray.7">{t(`landing.opportunities.${key}.text2`)}</Text>
              </Stack>
            </Card>
          ))}
        </SimpleGrid>
      </Container>
    </Box>
  );
}
